<template>
<v-list-tile>
  <v-list-tile-avatar >
    <v-icon small >attach_money</v-icon>
  </v-list-tile-avatar>
  <v-list-tile-content>

    <v-list-tile-title>
      {{ fullName }} paid {{ amountFormatted }} on {{ dateformat(item.date) }}
      <span v-if="item.method" >via {{ item.method }}.</span>
      <span v-if="item.reference" >ref: {{ item.reference }}</span>
    </v-list-tile-title>
    <v-list-tile-sub-title>
      <v-chip
        @click="gotoClient({id: item.customer_id})"
        class="v-chip--x-small ml-0"
        color="success" outline >
        {{ fullName }}
        <v-icon small style="font-size:12px;" right >open_in_new</v-icon>
      </v-chip>

      <v-chip outline
        v-for="invoice in item.related_invoices_formatted"
        :key="invoice.invoice_number"
        @click="gotoPage('invoice', invoice.invoice_number.split('-')[1])"
        class="v-chip--x-small ml-0"
        color="info" >
        <v-icon small style="font-size:12px;" left >post_add</v-icon>
        {{ invoice.invoice_number }}.
        {{ formatCurrency(invoice.currency, invoice.invoice_amount) }}
        <v-icon small style="font-size:12px;" right >open_in_new</v-icon>
      </v-chip>

      <v-chip class="v-chip--x-small ml-0" outline @click="showAppointments" >
        {{ appointments.length }} appointments
        <v-icon small style="font-size:12px;" right >open_in_new</v-icon>
      </v-chip>
    </v-list-tile-sub-title>
  </v-list-tile-content>
  <v-list-tile-action >
    <strong class='subheading' >{{ amountFormatted }}</strong>
  </v-list-tile-action>

  <v-dialog
    v-if="dialogs.appt"
    v-model="dialogs.appt" width="400" >
    <v-card>
      <request-status :request="requests.appt" />
      <v-card-title class="overline py-0 grey lighten-4" >
        Appointments
        <v-spacer/>
        <v-btn icon small @click="dialogs.appt=false" ><v-icon small >close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-list three-line >
        <template v-for="appt in remoteAppts" >
          <appointment-list-item
            @goto="gotoPage('appointment', appt.id)"
            :with-color-coding="false"
            :with-status-chips="true"
            :appointment="appt"
            :key="appt.id" />
          <v-divider :key="`div-${appt.id}`" />
        </template>
      </v-list>
      <!-- <pre v-text="remoteAppts" />
      <v-card-actions >
        <v-spacer/>
        <v-btn color="primary" ></v-btn>
      </v-card-actions>
      -->
    </v-card>
  </v-dialog>
</v-list-tile>
</template>

<script>
import AppointmentListItem from '@/components/appointment/AppointmentListItem.vue'
export default {
  name: 'PaymentListItem',
  components: {AppointmentListItem},
  props: {
    item: { type: Object, required: true }
  },
  data () {
    return {
      dialogs: {
        appt: false
      },
      requests: {
        appt: {
          resource: 'ag.practitioner.appointments'
        }
      }
    }
  },
  computed: {
    amountFormatted () {
      return this.formatCurrency(this.item.currency, this.item.amount)
    },
    relationship () {
      if (this.item && this.item.relationship_id) { return this.getRelationById(this.item.relationship_id) }
      if (this.item && this.item.customer_id) { return this.getRelationByClientId(this.item.customer_id) }
    },
    appointments () {
      return this.item.appointments || []
    },
    remoteAppts () {
      return this.getObjectPath(this.requests.appt, 'result.results', [])
    },
    fullName () {
      let firstName = this.getObjectPath(this.relationship, 'client.first_name')
      let lastName = this.getObjectPath(this.relationship, 'client.last_name')
      return `${firstName} ${lastName}`
    }
  },
  methods: {
    getAppts () {
      this.requests.appt.params = {
        'id-in': this.appointments.join(',')
      }
      this.$request('get', this.requests.appt)
    },
    showAppointments () {
      this.getAppts()
      this.dialogs.appt = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentListItem.vue?29d6195b